import React, { useEffect, useRef, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import { useDispatch } from 'react-redux';

import { hasBoards } from '../../../services/analysisContentService';

import IdentityManager from '../../../../common/services/identity/IdentityManagerFactory';

import { POPUP } from '../../../../redux/types';

import { INavigation } from '../../types/INavigation';

// @ts-ignore - In order for this to be fixed we need to make custom config rule
import LogoNav from '../../../../assets/images/logoNav.svg';
import { NavLink } from 'react-router-dom';

import './responsiveNavigation.scss';

const ResponsiveNavigation: React.FC<INavigation> = ({ setNav, id }) => {
  const [showBoards, setShowBoards] = useState<boolean>(true);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);

  const identity = IdentityManager.getManager();

  const clickOutsideHandler = () => {
    setNav(false);
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  useEffect(() => {
    hasBoards().then((r) => {
      setShowBoards(r.hasBoards);
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, []);

  return (
    <div className='responsive-nav-wrapper' ref={wrapperRef}>
      <NavLink end to='/home' className={({ isActive }) => (isActive ? `active-link` : ``)} onClick={() => setNav(false)}>
        <div className='responsive-nav-btn pointer'>
          {t('NAVIGATION.HOME')}
        </div>
      </NavLink>
      {showBoards && (
        <NavLink to='/boards' className={({ isActive }) => (isActive ? `active-link` : ``)}
                 onClick={() => setNav(false)}>
          <div className='responsive-nav-btn pointer'>
            {t('NAVIGATION.BOARDS')}
          </div>
        </NavLink>
      )}
      {/*<NavLink end to='/impersonate' className={({ isActive }) => (isActive ? `active-link` : ``)} onClick={() => setNav(false)}>*/}
      {/*  <div className='responsive-nav-btn pointer'>*/}
      {/*    {t('NAVIGATION.IMPERSONATION')}*/}
      {/*  </div>*/}
      {/*</NavLink>*/}
      <NavLink to='/documents' className={({ isActive }) => (isActive ? `active-link` : ``)}
               onClick={() => setNav(false)}>
        <div className='responsive-nav-btn pointer'>
          {t('NAVIGATION.DOCUMENTS')}
        </div>
      </NavLink>
      {/*<NavLink to='/docusign/sign' className={({ isActive }) => (isActive ? `active-link` : ``)}*/}
      {/*         onClick={() => setNav(false)}>*/}
      {/*  <div className='responsive-nav-btn pointer navigation-docusign'>*/}
      {/*    {t('NAVIGATION.DOCUSIGN')}*/}
      {/*  </div>*/}
      {/*</NavLink>*/}
      <NavLink to='/profile' className={({ isActive }) => (isActive ? `active-link` : ``)}
               onClick={() => setNav(false)}>
        <div className='responsive-nav-btn'>
          {t('NAVIGATION.PROFILE')}
        </div>
      </NavLink>
      <div className='responsive-nav-btn pointer sign-out-btn' onClick={() => identity.signOut()}>
        {t('NAVIGATION.LOGOUT')}
      </div>
      <img src={LogoNav} className='company-logo' alt={'CapInteract Logo'} />
    </div>
  );
};

export default ResponsiveNavigation;
